import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Typography } from '@mui/material'

import { GRTooltip } from '../../../../../components/GRTooltip/GRTooltip'
import { Game } from '../../../../../features/game/types/Game'
import { getMarketsSummary } from '../../helpers/gameListHelpers'

const NameList: FC<{ title: string; names: string[] }> = ({ title, names }) => (
  <Box>
    <Typography variant="subtitle2" fontWeight="bold">
      {title}
    </Typography>
    <Box component="ul" m={0} pl={2}>
      {names.map((name, index) => (
        <Typography component="li" variant="body2" key={`${name}-${index}`}>
          {name}
        </Typography>
      ))}
    </Box>
  </Box>
)

export const GameMarketsCell: FC<{ game: Game }> = ({ game }) => {
  const { t } = useTranslation()
  const { stores, markets } = getMarketsSummary(game)
  if (!stores.length && !markets.length) return <>---</>
  return (
    <GRTooltip
      content={
        <Box>
          <NameList title={t('internal-analysts:games_tooltip_stores')} names={stores} />
          <NameList title={t('internal-analysts:games_tooltip_markets')} names={markets} />
        </Box>
      }
    >
      <Typography component="span" sx={{ textDecoration: 'underline dotted', cursor: 'help' }}>
        {stores.length}, {markets.length}
      </Typography>
    </GRTooltip>
  )
}
